import { useSearchMyTasksQuery } from '@exam-management/graphql';
import { Link } from '@exam-management/router';
import { Loading } from '@shared/components';
import { useMemo } from 'react';

import { MyTaskCardListEmptyState, TaskCard } from '../../components';
import { useMyTaskSearchParams } from '../../hooks';

import { CARD_LIST_PAGE_SIZE, ORDER_FIELD_BY_STATUS, ORDER_TYPE_BY_STATUS } from './constants';
import { mapTasksToTaskCards } from './utils';

const MY_TASK_CARD_LIST_PATH = {
  'qset-review': '/my-task/qset-review/:taskId',
  'question-creation': '/my-task/question-creation/:taskId',
  'question-review': '/my-task/question-review/:taskId',
} as const;

export default function MyTaskCardList() {
  const [{ status, page }] = useMyTaskSearchParams();

  const { data: searchMyTasksData, loading: isLoading } = useSearchMyTasksQuery({
    variables: {
      searchMyTasksInput: {
        filter: { status },
        order: {
          field: ORDER_FIELD_BY_STATUS[status],
          type: ORDER_TYPE_BY_STATUS[status],
        },
        paging: {
          currentPage: page,
          pageSize: CARD_LIST_PAGE_SIZE,
        },
      },
    },
  });

  const mappedTasks = useMemo(
    () => mapTasksToTaskCards(searchMyTasksData?.wflSearchMyTasks.tasks ?? []),
    [searchMyTasksData],
  );

  if (isLoading) {
    return <Loading />;
  }

  if (!mappedTasks.length) {
    return <MyTaskCardListEmptyState taskStatus={status} />;
  }

  return mappedTasks.map((mappedTask) => {
    const path = MY_TASK_CARD_LIST_PATH[mappedTask.type];

    return (
      <Link
        to={path}
        params={{ taskId: mappedTask.id }}
        key={mappedTask.id}
        style={{ textDecoration: 'none' }}
      >
        <TaskCard {...mappedTask} />
      </Link>
    );
  });
}
